import React from "react";
// import './ToDoError.css';

function ToDoError() {
    return (
        <p>¡Ocurrió un Error!</p>
    );
};

export { ToDoError }